<div class="attachments-cards">
  @for (attachment of this.attachmentsValue; track attachment.id) {
    <cam-card [interactive]="true">
      <cam-card-content>
        <div class="attachment-row" (click)="this.openPreview(attachment)">
          <cam-local-icon [type]="this.iconType(attachment)" size="md"></cam-local-icon>

          <div class="attachment-info">
            <cam-text size="sm" [isBold]="true">{{ attachment.name }}</cam-text>
            <cam-text size="sm" color="secondary">{{ 'communication.attachments.annex' | translate }}</cam-text>
          </div>

          <cam-font-icon
            class="attachment-remove"
            name="close"
            type="sm"
            appStopPropagation
            (click)="this.remove(attachment)"
          ></cam-font-icon>
        </div>
      </cam-card-content>
    </cam-card>
  }

  <cam-button type="secondary" icon="add" class="attachments-add" (action)="this.open()">
    {{ 'communication.attachments.add' | translate }}
  </cam-button>
</div>

<cam-layout-full-panel
  [toggleState]="this.conversationAttachmentsModal.open()"
  (closeEvent)="this.conversationAttachmentsModal.open.set(false)"
  title="communication.documents.modal.title.attachments"
  type="modal"
  size="lg"
>
  @if (this.conversationAttachmentsModal.open()) {
    <cam-documents-attachments-modal-content
      [modalState]="this.conversationAttachmentsModal"
      [sectionsHelper]="this.sectionsHelper()"
      (closeEvent)="this.onConfirmed($event)"
    ></cam-documents-attachments-modal-content>
  }
</cam-layout-full-panel>

<cam-layout-full-panel
  [toggleState]="this.slideModal.open()"
  (closeEvent)="this.slideModal.open.set(false)"
  title="communication.attachments.preview-title"
  type="modal"
  size="lg"
  orientation="vertical"
>
  @if (this.slideModal.open()) {
    <cam-files-slide
      [initial]="this.slideModal.input()?.initial ?? null"
      [files]="this.slideModal.input()?.files ?? []"
    ></cam-files-slide>
  }
</cam-layout-full-panel>
